import { CommonModule } from '@angular/common';
import { Component, OnInit, Optional } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';
import { FiltroCotacoesRamoService } from '../../filtros/cotacoes-ramo/filtro-cotacoes-ramo.service';
import { Subscription } from 'rxjs';
import { FiltroComponent } from '../../filtro.component';

@Component({
  selector: 'sub-filtro-periodo-cotacoes',
  templateUrl: './periodo-cotacoes.component.html',
  styleUrls: ['../../filtro.component.scss'],
  imports: [
    CommonModule,
    ModulosDeFormulario,
    MatCheckboxModule,
    MatRadioModule,
    MatMenuModule,
  ],
})
export class PeriodoCotacoesComponent implements OnInit {
  protected readonly periodoOptions = IntegracaoConstants.periodoOptions;
  protected filtroPeriodo: number = 15;
  private filtroSubscription: Subscription;

  constructor(
    private filtroCotacoesRamo: FiltroCotacoesRamoService,
    @Optional() private filtroComp?: FiltroComponent
  ) {}

  ngOnInit(): void {
    this.filtroSubscription = this.filtroCotacoesRamo.periodo$.subscribe(
      (periodo) => (this.filtroPeriodo = periodo)
    );
  }

  ngOnDestroy(): void {
    this.filtroSubscription.unsubscribe();
  }

  onFiltroChange(newValue: number) {
    this.filtroPeriodo = newValue;
    this.filtroCotacoesRamo.changePeriodo(newValue);

    this.filtroComp?.sendFilter(false);
  }

  onRadioClick(event: MouseEvent, value: number) {
    if (this.filtroPeriodo === value) {
      event.preventDefault();
      this.filtroPeriodo = 15;
      this.filtroCotacoesRamo.changePeriodo(15);
    }
    
    this.filtroComp?.sendFilter(false);
  }
}